// 神策埋点 搜索点击
function sentSensors(plate, content) {
  var sensors = window["sensorsDataAnalytic201505"];
  if (sensors) {
    sensors.track("searchClick", {
      search_plate: plate,
      keyword_type: "关键词",
      keyword: content,
    });
    console.log("搜索点击埋点执行完毕");
  }
}

// 神策埋点 内容点击
function contentClick(contentId, contentName, contentType, currentPage) {
  var sensors = window["sensorsDataAnalytic201505"];
  if (sensors) {
    sensors.track("searchClick", {
      content_id: contentId, // 内容id
      content_name: contentName, // 内容名称
      content_type: contentType, // 内容类型
      current_page: currentPage, // 所在页面
    });
    console.log("内容点击埋点执行完毕");
  }
}

// 神策埋点 艺术点击
function authorClick(authorId, authorName) {
  var sensors = window["sensorsDataAnalytic201505"];
  if (sensors) {
    sensors.track("searchClick", {
      author_id: authorId, // 艺术号id
      author_name: authorName, // 艺术号名称
    });
    console.log("艺术点击埋点执行完毕");
  }
}

// 神策埋点 新闻点击
function newsClick(newsId, editorId) {
  var sensors = window["sensorsDataAnalytic201505"];
  if (sensors) {
    sensors.track("searchClick", {
      news_id: newsId, // 新闻id
      editor_id: editorId, // 编辑人id
    });
    console.log("新闻点击埋点执行完毕");
  }
}
function sendScData(name,json){
  var sensors = window["sensorsDataAnalytic201505"];
  if (sensors) {
    sensors.track(name, json);
  }
}
export { sentSensors, contentClick, authorClick, newsClick,sendScData };
